import { DataFarmType } from '../dataFarmType';
import { DataTransform } from '../dataTransform';
import { IncludeInfo } from '../includeInfo';
import { SortInfo } from '../sortInfo';
import { TransformRule } from '../transformRule';
import { TransformType } from '../transformType';

export class FarmConverterTransform extends DataTransform<FarmConverterTransformConfig> {

    constructor(id: number, index: number, name: string,nodeID:string) {
      super(id, name, index, TransformType.farmConverter,nodeID);
      this.transformConfig = new FarmConverterTransformConfig();
    }

    static fromJSON(data: any): FarmConverterTransform {
        //console.log(`fromJson invoked: ${data}`);
        const instance: FarmConverterTransform = Object.assign(new FarmConverterTransform(0, 0, '', ''), data);
        instance.transformConfig = FarmConverterTransformConfig.fromJSON(instance.transformConfig);

        return instance;
    }
    
    setRunAll(runAll: boolean): void {
        this.transformConfig.runAll = runAll;
    }
}

export class FarmConverterTransformConfig {
    farmType: DataFarmType;
    transformType: TransformType;
    sampleStart: number;
    sampleEnd: number;
    runAll: boolean;
    timestampField: string;
    groupBy: string;
    groupByL2: string;
    defSourceField: string;
    entityList: string;
    userField: string;
    bufferRows: number;
    threads: number;
    listSeparator: string;
    defTimeout: number;
    sequenceL2: boolean;
    delMisses: boolean;
    orderField : string;
    isOpenField: string;
    isCloseField: string;
    entityStart: string;
    entityEnd: string;
    subRows: string;
    addFields: string[];
    resetRows: boolean; 
    
    sortInfo?: SortInfo[];
    sortInfoOut?: SortInfo[];
    mapTable: FarmConverterRule[];

    noRules: boolean;
    
    static fromJSON(data: any): FarmConverterTransformConfig {
        //console.log(`fromJson invoked: ${data}`);
        const instance: FarmConverterTransformConfig = Object.assign(new FarmConverterTransformConfig(), data);

        const rules: FarmConverterRule[] = [];
        if (instance.mapTable) {
            instance.mapTable.forEach(r => {
                const rule = FarmConverterRule.fromJSON(r);
                rules.push(rule);
            });
        }
        instance.mapTable = rules;
        return instance;
    }
}

export enum IfErrorType {
    fail = 0,
    null = 1,
    zero = 2
}

export class IfErrorTypeUtil {
    static toString(type: IfErrorType): string {
        switch (type) {
            case IfErrorType.fail:
                return 'Fail';
            case IfErrorType.null:
                return 'NULL';
            case IfErrorType.zero:
                return '0';
        }
    }
}

export class FarmConverterRule {
    mapIndex: number;
    mapInclude: boolean;	
    mapFrom: string;	
    mapType: MapControlLegendType;	
    mapTo: string;	
    mapShow: boolean;
    isDefault: boolean;
    
    static fromJSON(data: any): FarmConverterRule {
        //console.log(`fromJson invoked: ${data}`);
        const instance: FarmConverterRule = Object.assign(new FarmConverterRule(), data);

        return instance;
    }
}
export enum MapControlLegendType {
    fcoptionone = 0,
    fcoptiontwo = 1,
    fcoptionthree = 2,
    fcoptionfour = 3,
    fcoptionfive = 4
}
